import React, { Component } from "react";
import axios from "axios";
import $ from "jquery";
import Headers from "../Layouts/Headers";
import { LabSidebar } from "../Layouts/LabSidebar";
import { MDBTableEditable } from "../_mdbcomponents/components/pro/TableEditable/TableEditable";
import { MDBCard } from "../_mdbcomponents/components/Card/Card";
import { MDBCardHeader } from "../_mdbcomponents/components/Card/CardHeader/CardHeader";
import { MDBDataTable } from "../_mdbcomponents/components/DataTable/DataTable";
import Loader from "../Layouts/Loader";
import { MDBCardBody } from "../_mdbcomponents/components/Card/CardBody/CardBody";

export class TestsRequested extends Component {
  constructor(props) {
    super(props);

   

    const url = "";

    this.state = {
       TestsRequested:[],
       loading: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.PrintWindow = this.PrintWindow.bind(this);
  }

  componentDidMount() {
    $(".form-control").each(function () {
      var thisvalue = $(this).attr("name");
      $(this).addClass(thisvalue);
      $(this).closest("h6").show();

      // this).(closest
    });

    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("currentVisitId"),
    };
    const TestsRequested = [];
    axios.get(this.api_url+"laboratory/requests/triage/off", {
        headers: headers,
      })
      .then((response) => {
        console.log(response.data);

        for (var i = 0; i < response.data.status.length; i++) {
         TestsRequested.push(response.data.status[i].testname)
          
        }

        this.setState({
          TestsRequested: TestsRequested
        })
      })
      .catch((error) => {
        console.log(error);
        $('#SubmitError').show();
        $(".alert-success").hide();
      });
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  PrintWindow(event) {
    document.title =
      localStorage.getItem("currentVisitName") + "`s " + this.constructor.name;
    $(".modal").hide();
    window.print();
  }

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("currentVisitId"),
    };
    event.preventDefault();
    console.log(localStorage.getItem("accessToken"));
    console.log(this.state);
    this.setState({
      loading: true
    })
  
  console.log(this.state)
 
const _ = require("lodash");  

const tests = _.omit(this.state, ['TestsRequested', 'loading'])

console.log(tests);
    axios
      .post(this.api_url+"laboratory/tests", tests, {
        headers: headers,
      })
      .then((response) => {
        console.log(response)
        this.setState({
          loading: false
        })
        if (response.data["status"]) {
          $("#loginSuccess").show();
          setTimeout(function () {
            //
            $(".checkHistory").click();
          }, 1500);
        }
      })
      .catch((error) => {
        console.log(error);
         this.setState({
          loading: false
        })
        $('#SubmitError').show();
        $(".alert-success").hide();
      });
  };

  render() {
    const font16 = { fontSize: "20px" };
    const fontFamilyNunito = {
      fontFamily: "Nunito, sans-serif",
      display: "none",
    };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };
    const width100 = { width: "100%" };
    const autoscroll = { overflowY: "auto" };

    const {
       TestsRequested, loading
    } = this.state;
    
    return (
      <div>
        <Headers />

        <LabSidebar />

        <main className="content-container">
          <div className="container p-2">
            <form onSubmit={this.handleSubmit}>
              <div className="col-md-12 font-livertotalbilr-bold p-1">
                <p className="text-capitalize" style={font16}>
                  Tests Requested
                </p>
              </div>

              <div className="form-row pt-4">
             {TestsRequested.map((field) => (
                 <div className="col-md-6 p-2">
                 <div className="py-1">
                   {/* <h6 className="text-capitalize" style={fontFamilyNunito}> */}
                     {field}
                   {/* </h6> */}
                   <input
                     className="form-control"
                     onChange={this.handleChange}
                
                     name={field}
                     type="text"
                     required
                   />
                 </div>
               </div>



             ))}

                

             


              </div>
              <div
                className="alert alert-danger"
                id="SubmitError"
                style={displayHidden}
                role="alert"
              >
                <strong> </strong>Something went wrong. Please try again
              </div>
              <div
                id="loginSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Details Saved Successfully.
              </div>

              <div className="row">
                <a
                  className="btn btn-primary checkHistory"
                  style={displayHidden}
                >
                  Check Patient History
                </a>
                {/* <div  className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-renalpotassium-bold data-entered" type="button" style={floatRight}>See the Data Entered</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-renalpotassium-bold"
                    type="submit"
                    style={floatLeft}
                  >
                   {loading ? 'Loading' : 'Submit'} 
                  </button>
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default TestsRequested;
